import { payOrder, orderPayJq, openYeeWallet, getOrderDetail, checkConsignPass } from "@/api/lst";
import { PLATFORM_JQ18, getStoredPlatformId } from "@/utils/apiPlatform";
import { JQ18_DEFAULT_PAY_CHANNEL, isBalancePayChannel, isYeepayPayChannel } from "@/constants/payChannel";
import { extractOrderPayStr, extractPayCashierUrl } from "@/utils/yeepayCashier";
import { yeepaySilentBalancePayFromOrderPay } from "@/utils/yeepayWallet";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** 5=待支付 6=已取消 */
export async function verifyJqOrderPaid(token, phone, orderId) {
    try {
        const res = await getOrderDetail(token, phone, String(orderId), "");
        if (Number(res?.code) !== 1 || !res?.data)
            return false;
        const st = Number(res.data.status);
        return st !== 5 && st !== 6;
    }
    catch {
        return false;
    }
}

async function payWithPass(token, phone, orderId, consignPass, payChannel) {
    const passRes = await checkConsignPass(token, phone, consignPass);
    if (Number(passRes.code) !== 1) {
        return passRes;
    }
    return orderPayJq(token, phone, {
        orderId,
        payChannel: Number(payChannel),
        resaleUuId: passRes.data
    });
}

/**
 * 镜权支付：checkConsignPass → order/pay → 易宝 WALLET_BALANCE 静默扣款（不走银行卡收银台）。
 */
export async function payOrderForPlatform(token, phone, orderId, consignPass, options = {}) {
    const jq = getStoredPlatformId() === PLATFORM_JQ18;
    const payChannel = options.payChannel ?? JQ18_DEFAULT_PAY_CHANNEL;
    const openWalletFirst = options.openWalletFirst === true;
    const silentYeepay = options.silentYeepay !== false;

    let res;
    if (jq) {
        if (openWalletFirst && isYeepayPayChannel(payChannel)) {
            try {
                await openYeeWallet(token, phone, payChannel);
            }
            catch (e) {
                console.warn("[orderPayJq18] openYeeWallet failed", e);
            }
        }
        if (isBalancePayChannel(payChannel) || isYeepayPayChannel(payChannel)) {
            res = await payWithPass(token, phone, orderId, consignPass, payChannel);
        }
        else {
            res = await orderPayJq(token, phone, { orderId, payChannel });
        }
    }
    else {
        res = await payOrder(token, phone, orderId, consignPass);
    }

    if (!jq) {
        return { ...res, _paySettled: Number(res.code) === 1, _yeepayOpened: false };
    }
    if (Number(res.code) !== 1) {
        return { ...res, _paySettled: false, _yeepayOpened: false };
    }

    if (isYeepayPayChannel(payChannel) && silentYeepay) {
        const hasToken = Boolean(extractOrderPayStr(res) || extractPayCashierUrl(res));
        if (!hasToken) {
            await sleep(350);
            if (await verifyJqOrderPaid(token, phone, orderId)) {
                return { ...res, _paySettled: true, _yeepayOpened: false };
            }
        }
        try {
            const yp = await yeepaySilentBalancePayFromOrderPay(res, consignPass);
            if (yp.ok) {
                await sleep(400);
                const paid = await verifyJqOrderPaid(token, phone, orderId);
                return { ...res, _paySettled: paid, _yeepayOpened: false, _yeepaySilent: true, _yeepayToken: yp.token };
            }
            console.warn("[orderPayJq18] yeepay silent pay failed", yp);
            return {
                ...res,
                _paySettled: false,
                _yeepayOpened: false,
                _yeepaySilent: false,
                _payError: yp.error || "易宝余额静默支付失败"
            };
        }
        catch (e) {
            console.warn("[orderPayJq18] yeepay silent pay error", e);
            return { ...res, _paySettled: false, _yeepayOpened: false, _payError: e.message || "易宝静默支付异常" };
        }
    }

    await sleep(350);
    const paid = await verifyJqOrderPaid(token, phone, orderId);
    return { ...res, _paySettled: paid, _yeepayOpened: false };
}
